import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import './ProfileAvatar.css'

const initialsOf = (name) => {
  if (!name) return '?'
  const parts = String(name).trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  const first = parts[0][0] || ''
  const last = parts.length > 1 ? parts[parts.length - 1][0] : ''
  return (first + last).toUpperCase()
}

const ProfileAvatar = ({ user, onChange }) => {
  const fileRef = useRef(null)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  const pick = () => {
    if (!busy && fileRef.current) fileRef.current.click()
  }

  const upload = async (e) => {
    const file = e.target.files && e.target.files[0]
    e.target.value = '' // let the same file be picked again after a failure
    if (!file) return

    if (file.size > 5 * 1024 * 1024) {
      setError('Image must be under 5 MB')
      return
    }

    setBusy(true)
    setError('')
    try {
      const body = new FormData()
      body.append('picture', file)
      const res = await fetch('/api/profile/picture', {
        method: 'POST',
        headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` },
        body,
      })
      const data = await res.json()
      if (!res.ok) {
        setError(data.error || 'Upload failed')
        return
      }
      const next = { ...(user || {}), profile_picture: data.profile_picture }
      localStorage.setItem('user', JSON.stringify(next))
      if (onChange) onChange(next)
    } catch (err) {
      setError('Upload failed')
    } finally {
      setBusy(false)
    }
  }

  const src = user && user.profile_picture

  return (
    <div className="profile-avatar-wrap">
      <button
        type="button"
        className="profile-avatar"
        onClick={pick}
        disabled={busy}
        title="Change profile picture"
        aria-label="Change profile picture"
      >
        {src ? (
          <img src={src} alt="" className="profile-avatar-img" />
        ) : (
          <span className="profile-avatar-initials">{initialsOf(user && user.full_name)}</span>
        )}
        <span className="profile-avatar-overlay">{busy ? '...' : 'Edit'}</span>
      </button>
      <input
        ref={fileRef}
        type="file"
        accept="image/*"
        onChange={upload}
        className="profile-avatar-input"
      />
      {error && <span className="profile-avatar-error">{error}</span>}
    </div>
  )
}

ProfileAvatar.propTypes = {
  user: PropTypes.object,
  onChange: PropTypes.func,
}

export default ProfileAvatar
